import React, { useState } from 'react';
import moment from 'moment';
import { formatDateForDisplay } from '../../utils/date';
import { applicationStatus } from '../../utils/enums';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Name from './Name';
import Status from './Status';
import Expanded from './Expanded';
import PlanActivationDialog from './Activation/Dialog';

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: ({ needsPlanDiscovery }: any) => {
      return needsPlanDiscovery ? 'pointer' : 'default';
    },
    '& .MuiTableCell-root': {
      paddingTop: ({ editing }: any) => {
        return editing ? theme.spacing(0.25) : 'normal';
      },
      paddingBottom: ({ editing }: any) => {
        return editing ? theme.spacing(0.25) : 'normal';
      },
    },
  },
  expandCell: { padding: theme.spacing(0.25) },
}));

export default function Plan({
  plan,
  updatePlanName,
  expandRow,
  numColumns,
  openPlanDiscovery,
  deletePlan,
  openContract,
  openContractAddendum,
  rejectEditedPlan,
  justSignedContract,
}) {
  const isPending = plan.status === applicationStatus.pending.status;
  const needsPlanDiscovery = isPending && !plan.completedPlanDiscovery;
  const [editing, setEditing] = useState(false);
  const classes = useStyles({ editing, needsPlanDiscovery });

  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        onClick={() => {
          if (isPending && !plan.completedPlanDiscovery) {
            setEditing(false);
            openPlanDiscovery(plan);
          }
        }}
      >
        <TableCell className={classes.expandCell}>
          {!needsPlanDiscovery && (
            <IconButton color="primary" onClick={() => expandRow(plan.id)}>
              {plan.expanded ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          )}
        </TableCell>
        <Name
          plan={plan}
          editing={editing}
          setEditing={setEditing}
          updatePlanName={updatePlanName}
        />
        <TableCell>
          {plan.start && moment(plan.start).isValid()
            ? formatDateForDisplay(plan.start)
            : '\u2014'}
        </TableCell>
        <Status
          status={plan.status}
          statusExpirationText={plan.statusExpirationText}
        />
        <TableCell style={{ width: 140 }}>
          {' '}
          {plan.contractSigned &&
            plan.status === applicationStatus.pending.status && (
              <PlanActivationDialog
                plan={plan}
                alreadySubmitted={plan.hasStatements}
                startOpen={justSignedContract}
              />
            )}
        </TableCell>
      </TableRow>
      <Expanded
        plan={plan}
        numColumns={numColumns}
        deletePlan={deletePlan}
        openContract={openContract}
        openContractAddendum={openContractAddendum}
        rejectEditedPlan={rejectEditedPlan}
      />
    </React.Fragment>
  );
}
